import React from "react";
interface HeroCardProps {
  herotitle: string;
  subTitle: string;
  span: string;
  title: string;
  subTitle1: string;
}
const HeroCard = ({
  herotitle,
  span,
  title,
  subTitle,
  subTitle1,
}: HeroCardProps) => {
  return (
    <div className="takaful--hero-section-content">
    <div className="takaful--hero-section-text">
        {/*   <div className="takaful--hero-title">
         <h1 className="takaful--title">{herotitle}</h1>
        </div>
        <h4>
          {subTitle}
          <span>{span}</span>
        </h4>
        <h1>{title}</h1>
        <h4>{subTitle1}</h4>*/}
      </div>
      {/*
      <div className="takaful--hero-section-icons">
        <a
          href="https://x.com/takafulsa"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={twitter} alt="X (Twitter)" />
        </a>
        <a
          href="https://www.linkedin.com/in/%D8%AC%D9%85%D8%B9%D9%8A%D8%A9-%D8%AA%D9%83%D8%A7%D9%81%D9%84-%D8%A7%D9%84%D8%AE%D9%8A%D8%B1%D9%8A%D8%A9-%D9%84%D8%B1%D8%B9%D8%A7%D9%8A%D8%A9-%D8%A7%D9%84%D8%A3%D9%8A%D8%AA%D8%A7%D9%85-%D8%A8%D8%A7%D9%84%D9%85%D8%AF%D9%8A%D9%86%D8%A9-%D8%A7%D9%84%D9%85%D9%86%D9%88%D8%B1%D8%A9-45850542"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={linkedin} alt="LinkedIn" />
        </a>
        <a
          href="https://www.instagram.com/takafulsa"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={instagram} alt="Instagram" />
        </a>
        <a
          href="https://www.youtube.com/takafulsa"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={youtube} alt="YouTube" />
        </a>
        <img src={line} alt="" className="takaful--hero-line" />
        <img
          src={groupe}
          alt=""
          style={{ width: "2.5em", height: "2.5em", pointerEvents: "none" }}
        />
      </div>
      */}
    </div>
  );
};

export default HeroCard;
